import { humanizeEventType } from '../utils/commerceEventTypes';

// Small dot + connecting line, deliberately mirroring OrderJourneyStepper's
// visual language (black dot, gray connector) so this reads as the same
// design system rather than a second timeline component with its own rules.
const DOT = 'bg-black';
const LINE = 'bg-gray-200';

function formatWhen(value) {
	if (!value) return '';
	const date = new Date(value);
	const time = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
	const day = date.toLocaleDateString([], { month: 'short', day: 'numeric' });
	return { time, day };
}

// approval: order.approval from getOrder (see orders/detail.js), used only to
// enrich the order.approved row with the approver's name -- decided_by_name
// is resolved server-side (orderApprovals.service.ts#getOrderApprovalSummary)
// rather than threaded through the event payload itself.
export default function OrderTimeline({ events, approval }) {
	if (!events?.length) {
		return <p className='text-sm text-gray-400'>No events recorded yet.</p>;
	}

	// commerce_events is fetched DESC (newest first, see commerceEvents.service.ts);
	// a timeline reads top-to-bottom as oldest-first.
	const sorted = [...events].sort((a, b) => new Date(a.occurredAt) - new Date(b.occurredAt));

	return (
		<ul>
			{sorted.map((event, i) => {
				const isLast = i === sorted.length - 1;
				const { time, day } = formatWhen(event.occurredAt);
				const detail =
					event.eventType === 'order.approved' && approval?.decided_by_name
						? `Approved by ${approval.decided_by_name}`
						: null;
				return (
					<li key={event.commerceEventId ?? event.eventId ?? i} className='flex gap-3'>
						<div className='flex flex-col items-center'>
							<div className={`w-2.5 h-2.5 rounded-full shrink-0 mt-1 ${DOT}`} />
							{!isLast && <div className={`w-0.5 flex-1 my-1 ${LINE}`} />}
						</div>
						<div className={`pb-4 ${isLast ? '' : ''}`}>
							<div className='flex items-baseline gap-2'>
								<span className='text-sm font-medium'>{humanizeEventType(event.eventType)}</span>
								<span className='text-xs text-gray-400'>
									{day} {time}
								</span>
							</div>
							{detail && <p className='text-xs text-gray-500 mt-0.5'>{detail}</p>}
						</div>
					</li>
				);
			})}
		</ul>
	);
}
